import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'

import { urlToHost } from "../../utilities/FrontFunctions/AoxFrontFunctions"
import '../../assets/css/0020_objects/0600_obj_menu_thematique_aside.css';

class ObjMenuThematiqueAside extends Component {
	render() {
        const { datasThemes, themeId } = this.props;

		return (<>{datasThemes && <>
			<div className="obj_menu_aside_thematiques">
				<h3 className="t_title">Thématiques</h3>
				
				<ul className="obj_menu_aside_list">
                    { datasThemes.map((datasTheme, index) => (
                        <li
                            key={index}
                            className={`menu_aside-item ${
                                (datasTheme.id === themeId) ? 'is_current' : ''
                            }`}
                        >
                            <a href={urlToHost(datasTheme.url)}>
                                {datasTheme.pageTitle.value}
                            </a>
                        </li>
                    ))}
				</ul>
				
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjMenuThematiqueAside));